module.exports = __webpack_public_path__ + "img/kcHyNone.29ff219a.png";